import * as angular from 'angular';

import { SvgManager } from '../../charting/SvgManager';
import { ICompilableScope, IDynamicCompileService } from '../services/dynamicCompileService';
import { Dependencies } from '../../diagrams/index';
import { DependencyConfiguration } from '../../diagrams/dependencies/DependencyConfiguration';
export interface IwtDependenciesScope extends ICompilableScope {
    data: any;
    configuration: DependencyConfiguration;
}

export class WtDependencies {
    public static directiveId = 'wtDependencies';
    template = '<div class="dependency-element"><svg></svg></div>';
    scope = {
        data: '=',
        configuration: '='
    };
    replace = true;

    constructor(private _dynamicCompileService: IDynamicCompileService) {
        this.link.bind(this);
    }

    link = ($scope: IwtDependenciesScope, element: angular.IAugmentedJQuery, attrs) => {
        const id = attrs['id'];
        if (!id) {
            console.error('An id is required in order to use wtDependencies');
        } else {
            element.attr('id', id);
            const mgr = new SvgManager(id, {
                marginTop: 0,
                marginBottom: 0,
                marginLeft: 0,
                marginRight: 0
            });
            const chart = new Dependencies(mgr);
            $scope.$watch(() => $scope.data, (newValue) => {
                if (newValue) {
                    chart.update(newValue);
                    $scope.series = [$scope.data];
                    this._dynamicCompileService.compileGroup(element, $scope);
                }
            });

            $scope.$watch(() => $scope.configuration, (newValue: any) => {
                if (newValue) {
                    chart.configuration(newValue);
                }
            }, true);

            chart.dispatch.on('onNodeClick', d => {
                this._dynamicCompileService.compileGroup(element, $scope);
            });
        }
    }
}
